import "./plugins/jquery.modal";
import { tns } from '../node_modules/tiny-slider/src/tiny-slider';

$(function(){
  var heroSlider = tns(
    {
      container: "#homepage-hero-slider",
      speed: 500,
      autoplay: true,
      lazyload: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3500,
      controls: false,
      controlsText: [
        "<i data-icon=\"ì\"></i>",
        "<i data-icon=\"í\"></i>"
      ],
      autoplayText: [
        "▶",
        "❚❚"
      ],
      preventScrollOnTouch: "auto",
      responsive: {
        600: {touch: true},
        768: {controls: true},
      }
    }
  );

  var heroSliderArrow = document.querySelectorAll('.tns-controls')
  heroSliderArrow.forEach(function (button) {
    button.addEventListener('mouseover', function (e) {
      heroSlider.pause()
    })

    button.addEventListener('mouseout', function (e) {
      heroSlider.play()
    })
  });

  var heroSliderDot = document.querySelectorAll('.tns-nav button')
  heroSliderDot.forEach(function (button) {
    button.addEventListener('mouseover', function (e) {
      heroSlider.pause()
    })

    button.addEventListener('mouseout', function (e) {
      heroSlider.play()
    })
  });

  var prevButton = '<span class="glide__arrow glide__arrow--left"><i data-icon="ì"></i></span>';
  var nextButton = '<span class="glide__arrow glide__arrow--right"><i data-icon="í"></i></span>';
  var categorySlider = tns(
    {
      container: "#popular-categories-slider",
      items: 3.5,
      slideBy: 3,
      loop: false,
      lazyload: true,
      controlsText: [prevButton, nextButton],
      speed: 700,
      nav: false,
      controls: false,
      preventScrollOnTouch: "auto",
      mouseDrag: true,
      touch: false,
      responsive: {
        600: {items: 5, slideBy: 5, nav:true, controls: true, mouseDrag: false,touch: true},
        768: {items: 7, slideBy: 7}
      }
    }
  );

  var brandSlider = tns(
    {
      container: "#shop-by-brand-slider",
      items: 3.5,
      slideBy: 3,
      lazyload: true,
      loop: false,
      controlsText: [prevButton, nextButton],
      speed: 700,
      nav: false,
      controls: false,
      mouseDrag: true,
      preventScrollOnTouch: "auto",
      touch: false,
      onInit: function () {
        var all = document.getElementsByClassName('popular-categories-slider');
        for (var i = 0; i < all.length; i++) {
          all[i].style.visibility = 'visible';
        }
      },
      responsive: {
        600: {items: 5, slideBy: 5, nav: true, controls: true, mouseDrag: false,touch: true}}
      }
  );

  const productSliders = document.querySelectorAll('.tns-product-collection-slider');
  productSliders.forEach(slider => {
    const tnsSlider = tns({
      container: slider,
      items: 2.5,
      slideBy: 2,
      lazyload: true,
      loop: false,
      controlsText: [prevButton, nextButton],
      speed: 700,
      nav: false,
      controls: false,
      mouseDrag: true,
      touch: false,
      preventScrollOnTouch: "auto",
      responsive: {
        600: {items: 3, slideBy: 3, nav: true, controls: true, mouseDrag: false,touch: true},
        768: {items: 4, slideBy: 4},
        1024: {items: 5, slideBy: 5}
      }
      });
    });
});
